export default __webpack_public_path__ + "static/media/shape-image.290611e8.svg";